<template>
  <v-container fill-height fluid class="pa-0 ma-0">
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="structured_logs"
          :items-per-page="100"
          :item-class="row_class"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-btn outlined @click="refreshLogs(jobid)">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.level="{ item }">
            <v-icon :color="item._source.color" small>
              {{ item._source.icon }}
            </v-icon>
            <span class="mx-2">{{
              capitalizeFirstLetter(item._source.level)
            }}</span>
          </template>
          <template v-slot:item.json="{ item }">
            {{ item._source.json.name }}: {{ item._source.json.filename }}[{{
              item._source.json.lineno
            }}] -
            {{ item._source.json.message }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
import { API, OWL_PIPELINE_LOGS } from "@/axios-config";

export default {
  name: "LogViewer",
  props: ["jobid"],
  data() {
    return {
      logs: {},
      headers: [
        { text: "Level", value: "level" },
        { text: "Date", value: "_source.@timestamp" },
        { text: "Message", value: "json", width: "60%" },
      ],
      structured_logs: [],
    };
  },
  methods: {
    row_class(item) {
      if (item._source.level.includes("WARNING")) {
        return "orange lighten-4";
      } else if (item._source.level.includes("ERROR")) {
        return "red lighten-4";
      } else if (item._source.level.includes("CRITICAL")) {
        return "red lighten-4";
      } else if (item._source.level.includes("INFO")) {
        return "light-blue lighten-5";
      } else {
        return "";
      }
    },
    async logsPipeline(value) {
      try {
        const { data } = await API.get(OWL_PIPELINE_LOGS, {
          params: {
            jobid: parseInt(value),
          },
        });
        this.logs = data;
        this.getStructuredLogs();
      } catch (error) {
        console.log(error);
      }
    },
    capitalizeFirstLetter(string) {
      try {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      } catch (error) {
        return "";
      }
    },
    getStructuredLogs() {
      this.logs.hits.hits
        .filter((v) => v._source.message.includes("asctime"))
        .forEach((element) => {
          if (element._source.message.includes("DEBUG")) {
            element._source.level = "DEBUG";
            element._source.color = "blue";
            element._source.icon = "mdi-bug";
          } else if (element._source.message.includes("INFO")) {
            element._source.level = "INFO";
            element._source.color = "blue";
            element._source.icon = "mdi-information";
          } else if (element._source.message.includes("WARNING")) {
            element._source.level = "WARNING";
            element._source.color = "orange";
            element._source.icon = "mdi-alert";
          } else if (element._source.message.includes("ERROR")) {
            element._source.level = "ERROR";
            element._source.color = "red";
            element._source.icon = "mdi-alert-circle";
          } else if (element._source.message.includes("CRITICAL")) {
            element._source.level = "CRITICAL";
            element._source.color = "red";
            element._source.icon = "mdi-alert-octagon";
          } else {
            element._source.level = "INFO";
            element._source.color = "blue";
            element._source.icon = "mdi-information";
          }
          if (element._source["@timestamp"]) {
            element._source["@timestamp"] = new Date(
              element._source["@timestamp"]
            ).toLocaleString();
          }

          try {
            element._source.json = JSON.parse(element._source.message);
          } catch (error) {
            element._source.json = {
              name: "Unknown",
              filename: "Unknown",
              lineno: "0",
              message: element._source.message,
            };
          }

          // if (element._source.json.message) {
          //   element._source.json.message = element._source.json.message.replace(
          //     /(?:\r\n|\r|\n)/g,
          //     "<br />"
          //   );
          // }

          this.structured_logs.push(element);
        });

      // this.structured_logs = this.structured_logs.filter((v) => v._source.json);
    },
    refreshLogs(value) {
      this.structured_logs = [];
      this.logsPipeline(value);
    },
  },
  watch: {
    jobid: {
      handler(value) {
        if (value) {
          this.refreshLogs(value);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
  